import React, {useEffect, useState} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import SurveyChat from './SurveyChat';
import {useAuth} from "../AuthContext";

const API_URL = process.env.REACT_APP_API_URL;


const SurveyContainer = () => {
    const {shortcode} = useParams(); // Get survey shortcode from URL
    const [searchParams] = useSearchParams(); // Get query parameters
    const [survey, setSurvey] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    useEffect(() => {
        // Fetch the survey data based on the ID and include session parameter
        const fetchSurvey = async () => {
            try {
                // Get session from URL query parameters
                const session = searchParams.get('session');
                
                // Add session parameter to API request if present
                const apiQueryParams = session ? `?session=${session}` : '';
                const response = await fetch(`${API_URL}/api/shortcode/${shortcode}${apiQueryParams}`);
                const data = await response.json();
                // Commented out hardcoded theme - use theme from survey data instead
                // data.data.theme="corporate";
                setSurvey(data.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching survey:', error);
                setLoading(false);
            }
        };

        fetchSurvey();
    }, [shortcode, searchParams]);

    if (loading) {
        return <p>Loading survey...</p>;
    }

    if (!survey) {
        return <p>Survey not found.</p>;
    }

    console.log('Survey theme:', survey.theme);
    return <SurveyChat survey={survey} theme={survey.theme || 'corporate'} />;
};

export default SurveyContainer;